import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import {
  Box,
  UnorderedList,
  Heading,
  Link,
  Paragraph,
  Button,
} from 'components';
import './OurOffer.scss';
import { data } from './logic.js';

class OurOffer extends Component {
  renderOffers = () =>
    data.map((item, index) => {
      const { order, title, description, bullets, link, id } = item;

      return (
        <div className={'our-offer__box'} key={order}>
          <Box
            key={`offer-${index}`}
            backgroundColor={'transparent'}
            additionalClass={'anim-fade-in-bottom'}
          >
            <Link to={link} arrow>
              <div className={'our-offer__item'}>
                <div className={'our-offer__tile'}>
                  <div className={'our-offer__info'}>
                    <Heading
                      type={3}
                      size={'medium-plus'}
                      color={'white'}
                      additionalClass={'our-offer__headline'}
                    >
                      {ReactHtmlParser(title)}
                    </Heading>
                    <Paragraph
                      color={'white'}
                      additionalClass={'our-offer__number'}
                    >
                      {order}
                    </Paragraph>
                  </div>
                  <Paragraph
                    color={'white'}
                    additionalClass={'our-offer__description'}
                  >
                    {ReactHtmlParser(description)}
                  </Paragraph>
                  {bullets && (
                    <UnorderedList
                      containerClass={'our-offer__bullets'}
                      additionalClass={'text--white text--light'}
                      items={bullets}
                    />
                  )}
                  {link && (
                    <Button color={'white'} id={id} transparent>
                      Read more
                    </Button>
                  )}
                </div>
              </div>
            </Link>
          </Box>
        </div>
      );
    });

  render() {
    return <div className={'our-offer__container'}>{this.renderOffers()}</div>;
  }
}

export default OurOffer;
